import React from "react";
import styles from "./loading-modal.module.css";

function LoadingModal({ isLoading, message = "Loading..." }) {
  if (!isLoading) return null;

  return (
    <div className={styles.modalBackdrop}>
      <div className={styles.modalContent}>
        <div
          className={`${styles.spinner} ${"animate-spin rounded-full"}`}
        ></div>
        <p>{message}</p>
      </div>
    </div>
  );
}

export default LoadingModal;
